/* 防抖 */
function debounce(func, wait) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  }
}

/* 修改路由参数（不新增历史记录） */
const appendQueryParameter = (key, value) => {
  const href = window.location.href;
  const startIndex = href.indexOf('?');
  const rootUrl = startIndex > -1 ? href.slice(0, startIndex) : href;
  let query = [];
  if (startIndex > -1) {
    query = href.slice(startIndex + 1).split('&').filter(Boolean);
  }
  const keyIndex = query.findIndex(item => item.startsWith(`${key}=`));
  if (keyIndex > -1) {
    query[keyIndex] = `${key}=${encodeURIComponent(value)}`;
  } else {
    query.push(`${key}=${encodeURIComponent(value)}`);
  }
  const newUrl = `${rootUrl}?${query.join('&')}`;
  // 用 replaceState 替换当前地址，而不是 pushState
  window.history.replaceState({}, '', newUrl);
};

/* 加入购物车 */
const handleCartAdd = async (productId, quantity, $this) => {
  $this.attr('disabled', true);
  $(document).on('cart:updated', function(e) {
    $this.attr('disabled', false);
    $(document).off('cart:updated');
  });
  const cartAddUrl = T4Sroutes.cart_add_url + '.js';
  const strCartDataMini = (T4Sconfigs.cartType == 'disable') ? 'cart_data' : 'cart_data,mini_cart';
  const sections_nt = (T4Srequest.page_type != 'cart') ? strCartDataMini : `cart_data,${window.cartT4SectionID}`;
  const sections_ntArray = sections_nt.split(',');
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/javascript',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      "id": productId,
      "quantity": quantity,
      "sections": sections_ntArray,
      "sections_url": window.location.pathname
    })
  };
  fetch(`${cartAddUrl}`, config)
  .then((response) => response.json())
  .then((response) => {
    if(response.status) {
      T4SThemeSP.Notices(response.description);
      $(document).trigger('cart:updated');
      return;
    }
    if(T4SThemeSP.isEditCartReplace && response.variant_id != T4SThemeSP.iDVariantEdit){
      console.log('11111');
    }else{
      $(document).trigger('add:cart:success').trigger('add:cart:upsell');
      T4SThemeSP.isATCSuccess = true;
      if (response.sections) {
        T4SThemeSP.Cart.renderContents(response.sections);
      } else {
        T4SThemeSP.Cart.getToFetch();
      }
    }
  }).catch((e) => {
    $(document).trigger('cart:updated');
    // console.error(e);
  }).finally(() => {});
};
const handleCartAddCon = debounce(handleCartAdd, 500);